import { ChecklistProgressState } from "source/app/features/checklists/state/checklist-progress-state.store";
import { LocationState } from "./location-state.store";
import { ChecklistState } from "source/app/features/checklists/state/checklist-state.store";
import { UiState } from "./ui.store";

export function elfMigration() {
	const akitaStores = localStorage.getItem("AkitaStores");

	if (akitaStores) {
		// load stores
		const akitaData: AkitaData = JSON.parse(akitaStores);

		// fill stores
		if (akitaData.checklist != null) {
			localStorage.setItem("checklist-state@store", JSON.stringify(akitaData.checklist));
		}
		if (akitaData.checklistProgress != null) {
			localStorage.setItem("checklist-progress-state@store", JSON.stringify(akitaData.checklistProgress));
		}

		localStorage.setItem("location-state@store", JSON.stringify(akitaData.locationState));
		localStorage.setItem("ui@store", JSON.stringify(akitaData.ui));

		if (akitaData.fileUploads != null) {
			// the entity stores have meta data, that we dont need in elf
			const fileUploads: EntitiesStore = {
				ids: akitaData.fileUploads.ids,
				entities: akitaData.fileUploads.entities,
			};
			localStorage.setItem("file-uploads@store", JSON.stringify(fileUploads));
		}

		if (akitaData.fileTranslations != null) {
			// the entity stores have meta data, that we dont need in elf
			const fileTranslations: EntitiesStore = {
				ids: akitaData.fileTranslations.ids,
				entities: akitaData.fileTranslations.entities,
			};
			localStorage.setItem("file-translations@store", JSON.stringify(fileTranslations));
		}

		if (akitaData.actions != null) {
			// the entity stores have meta data, that we dont need in elf
			const actions: EntitiesStore = {
				ids: akitaData.actions.ids,
				entities: akitaData.actions?.entities,
			};
			localStorage.setItem("actions@store", JSON.stringify(actions));
		}

		// lets back it up
		localStorage.setItem("akita_backup", akitaStores);

		// delete old data
		localStorage.removeItem("AkitaStores");
		console.log("migration to elf done");
	}
}

interface AkitaData {
	checklist: ChecklistState;
	checklistProgress: ChecklistProgressState;
	fileTranslations: EntitiesStore;
	fileUploads: EntitiesStore;
	locationState: LocationState;
	actions: EntitiesStore;
	ui: UiState;
}

interface EntitiesStore {
	entities: object;
	ids: string[];
}
